import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationPresenterComponent } from './registration-presenter/registration-presenter.component';
import { RegistrationContainerComponent } from './registration-container/registration-container.component';
import { RegistrationRouteModule } from './registration.route';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [
        RegistrationPresenterComponent,
        RegistrationContainerComponent
    ],
    imports: [CommonModule, SharedModule, RegistrationRouteModule]
})
export class RegistrationModule {}
